module.exports = __webpack_public_path__ + "static/media/landline-footer.6f329edd.svg";